export default "__VITE_ASSET__Dd3sb2I7__"